module.exports = __webpack_public_path__ + "static/media/white.05562aa0.svg";